import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from "react-router-dom";
import { createMemoryHistory } from "history";
import { OcrProvider } from "./context/OcrContext";
import { LanguageProvider } from "./context/LanguageContext";
import { restoreBillingRoute, rememberBillingRoute } from './utils/billingRouteSession';

import App from './App';
import * as serviceWorker from './serviceWorker';

//import './App.css';
import './assets/scss/style.scss';
// Phone-only overrides (max-width: 767px). Must load last.
import './styles/mobile.css';

const initialPath =
  `${window.location.pathname || "/"}${window.location.search || ""}`;

// Keep Memory History, but allow direct review links from Box to open correctly.
const history = createMemoryHistory({
  initialEntries: [restoreBillingRoute(window.sessionStorage, initialPath)],
});
history.listen(location => rememberBillingRoute(window.sessionStorage, location));

ReactDOM.render(
  <LanguageProvider>
    <OcrProvider>
      <Router history={history}>
        <App />
      </Router>
    </OcrProvider>
  </LanguageProvider>,
  document.getElementById('root')
);

// Keep dev/prod deployments fresh. A cached service worker can keep serving an
// older bundle after the VM has already been redeployed.
serviceWorker.unregister();
